module.exports = __webpack_public_path__ + "img/10.7f371c18.png";